import { InventorySearchInput } from '../../../components/inventory-search-input';

interface MapSearchHeaderProps {
  /** Current search term (shared `search` URL param). */
  value: string;
  /** Writes the term back to the URL. */
  onChange: (next: string) => void;
  /** Translated placeholder, shared with the catalog search box. */
  placeholder: string;
  /** Translated aria-label, shared with the catalog search box. */
  ariaLabel: string;
}

/**
 * Search header strip rendered above the map canvas (not overlaying it). Hosts
 * the same {@link InventorySearchInput} the catalog uses so both screens look and
 * behave the same. The parent gates this behind the map-coordinate-search flag.
 */
export function MapSearchHeader({ value, onChange, placeholder, ariaLabel }: MapSearchHeaderProps) {
  return (
    <div
      className="border-b border-border/40 bg-background px-4 py-2"
      data-testid="map-search-header"
    >
      <InventorySearchInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        ariaLabel={ariaLabel}
      />
    </div>
  );
}
